import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import DOMPurify from 'dompurify';
import { useFetch } from '../../hooks/useFetch';
import { articlesApi } from '../../api/articlesApi';
import { SkeletonText } from '../../components/ui/Skeleton';
import { Seo } from '../../components/ui/Seo';
import './ArticleDetail.css';

const API_URL = process.env.REACT_APP_API_URL;

export function ArticleDetail() {
  const { slug } = useParams();
  const { data: article, loading } = useFetch(() => articlesApi.getBySlug(slug), [slug]);

  if (loading) {
    return (
      <div className="article-page">
        <div className="prose-page"><SkeletonText lines={6} /></div>
      </div>
    );
  }
  if (!article) return <p className="prose-page">Article introuvable.</p>;

  return (
    <div className="article-page">
      <div className="prose-page article-detail">
        <Seo
          title={article.titre}
          description={article.extrait || `${article.titre} — AXEO Services Cergy`}
          path={`/blog/${article.slug}`}
          image={article.image_couverture ? `${API_URL}${article.image_couverture}` : undefined}
        />

        <Link to="/blog" className="article-detail__back">
          <ArrowLeft size={16} /> Retour aux actualités
        </Link>

        <article className="article-detail__card">
          <header className="article-detail__header">
            {article.categorie_nom && <span className="article-detail__tag">{article.categorie_nom}</span>}

            <h1 className="article-detail__title">{article.titre}</h1>

            {article.extrait && <p className="article-detail__excerpt">{article.extrait}</p>}
          </header>

          {article.image_couverture && (
            <img className="article-detail__image" src={`${API_URL}${article.image_couverture}`} alt="" />
          )}

          <div
            className="article-detail__content"
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(article.contenu) }}
          />
        </article>
      </div>
    </div>
  );
}
